import { configureStore } from '@reduxjs/toolkit';
import { accountManagerReducers } from '@tecma/module-account-manager';
import { calendarReducers } from '@tecma/module-calendar';

import { sliceEnvironment } from './slice/slice.environment';
import { sliceI18n } from './slice/slice.i18n';

export const reduxStore = configureStore({
  reducer: {
    ...calendarReducers,
    ...accountManagerReducers,
    environment: sliceEnvironment.reducer,
    i18n: sliceI18n.reducer,
  },
});
